import { styled } from "styled-components";

export const VideoWrapper = styled.div`
  padding: 60px 0;
  @media all and (max-width: 768px) {
    padding: 8.889vw 0;
  }
`;

export const VideoWrap = styled.div``;

export const VideoTitleWrap = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 24px;
  padding: 60px 0 80px;
  h3 {
    font-family: "AnekLatin-semibold";
    font-weight: 600;
    font-size: 72px;
    color: #171717;
  }
  p {
    font-size: 24px;
    line-height: 1.3;
    color: #242424;
  }
  @media all and (max-width: 768px) {
    gap: 4.688vw;
    padding: 5.208vw 0 9.375vw;
    h3 {
      font-size: 11.25vw;
    }
    p {
      font-size: 5vw;
    }
  }
`;

export const VideoCategoryListWrap = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  margin-bottom: 40px;
  li {
    color: #c1c1c1;
    font-weight: bold;
    font-size: 24px;
    line-height: 1.3;
    cursor: pointer;
    &.active {
      color: #171717;
    }
  }
  @media all and (max-width: 768px) {
    gap: 5.208vw;
    margin-bottom: 6.51vw;
    li {
      font-size: 4.427vw;
    }
  }
`;

export const VideoListWrap = styled.ul`
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
  cursor: pointer;
  li {
    width: calc(25% - 60px / 4);
    > div {
      display: flex;
      flex-direction: column;
      gap: 12px;
      .img-wrap {
        height: 200px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .text-wrap {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 4px;
        p {
          font-weight: bold;
          font-size: 20px;
          line-height: 1.4;
          color: #242424;
        }
        span {
          font-size: 14px;
          color: #6f6f6f;
          line-height: 1.4;
        }
      }
    }
  }
  @media all and (max-width: 1180px) {
    li {
      > div {
        .img-wrap {
          height: 16.949vw;
        }
      }
    }
  }
  @media all and (max-width: 1024px) {
    li {
      width: calc(33.333% - 40px / 3);
      > div {
        .img-wrap {
          height: 19.531vw;
        }
      }
    }
  }
  @media all and (max-width: 768px) {
    gap: 2.604vw;
    li {
      width: calc(50% - 1.302vw);
      > div {
        gap: 2.083vw;
        .img-wrap {
          height: 31.25vw;
        }
        .text-wrap {
          gap: 0.781vw;
          p {
            font-size: 3.906vw;
          }
          span {
            font-size: 3.385vw;
          }
        }
      }
    }
  }
  @media all and (max-width: 640px) {
    gap: 4.688vw;
    li {
      width: 100%;
      > div {
        .img-wrap {
          height: 40vw;
        }
      }
    }
  }
`;

export const YoutubeModalWrap = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;

  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const YoutubeModalDim = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
  position: absolute;
  z-index: -1;
`;
